import ApiTools from './apiTools';
import type { TermsAndConditions } from '@vidende/contracts';

// `TermsAndConditions` now lives in @vidende/contracts; re-exported here so existing
// `@brallum/vidende/src/api/termsAndConditionsApi` type importers keep working.
export type { TermsAndConditions } from '@vidende/contracts';

class TermsAndConditionsApi {
    static getTermsAndConditions(): Promise<TermsAndConditions[]> {
        return ApiTools.get(`VersionedTemplates/getTermsAndConditions`).then(
            (response: { data: TermsAndConditions[] }) => {
                return response.data;
            },
        );
    }
    static acceptTermsAndConditions(
        termsAndConditions: {
            [key: string]: { value: boolean; id: number };
        },
        sendEmail: boolean,
    ) {
        return ApiTools.post(`VersionedTemplates/acceptTermsAndConditions`, {
            termsAndConditions,
            sendEmail,
        }).then((response) => {
            return response;
        });
    }
}

export default TermsAndConditionsApi;
